
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/rationality-and-acceptance",
      function () {
        return require("private-next-pages/articles/rationality-and-acceptance.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/rationality-and-acceptance"])
      });
    }
  